"use client";
import BreadCrumb from "@/components/global/BreadCrumb";
import ProductItem from "@/components/global/ProductItem";
import productApi from "@/service/modules/productApi";
import Link from "next/link";
import { useEffect, useState } from "react";
import { Button, Image, ImagePreview } from "react-vant";
import type { ProductType } from "@/types/product";

// 首先定义类型接口
interface CategoryProduct {
  categoryName: string;
  categoryId: string;
  items: ProductType[];
}

export default function Afterpay() {
  const breadcrumData = [
    { name: "Online Shopping", url: "/", current: false },
    { name: "Afterpay", url: "/afterpay", current: true },
  ];
  const [imgVisible, setImgVisible] = useState(false);
  const [imagesArr, setImagesArr] = useState<string[]>([]);
  const [categoryProduct, setCategoryProduct] = useState<CategoryProduct[]>([]);

  const getProductList = async () => {
    try {
      const resData = await productApi.getCategoryProductTopFive();

      if (resData.data && resData.data) {
        setCategoryProduct(resData.data);
      }
    } catch (error) {
      console.log(`shop页面extra数据获取失败： `, error);
    }
  };

  useEffect(() => {
    getProductList();
  }, []);
  return (
    <div className="afterpay-page">
      <BreadCrumb BreadList={breadcrumData} />
      <div>
        <Image src={`${process.env.IMAGE_DOMAIN}/afterpay/afterpay-top.jpg`} alt="Afterpay" />
      </div>
      <h4 style={{ textAlign: "center", fontWeight: 600, margin: "24px 0" }}>
        How to Use Afterpay at BestDeals
      </h4>
      {new Array(6).fill(0).map((_, index) => (
        <Image
          key={index}
          alt={`Afterpay step ${index + 1}`}
          src={`${process.env.IMAGE_DOMAIN}/afterpay/afterpay${index + 1}.jpg`}
          style={{ marginBottom: 48 }}
          onClick={() => {
            setImagesArr([
              `${process.env.IMAGE_DOMAIN}/afterpay/afterpay-pop${index + 1}.png`,
            ]);
            setImgVisible(true);
          }}
        />
      ))}

      <div className="article-page">
        <div className={`afterpay-explain-title padding-top-50`}>
          Shop Now, Enjoy Now, Pay Later
        </div>
        <div className={`afterpay-explain-desc padding-top-8`}>
          {`BestDeals is one of Afterpay stores in New Zealand. Afterpay is a buy now, pay later platform that lets you pay for your items in 4 instalments over 6 weeks, interest free. To use Afterpay, add items to your shopping cart then select Afterpay from the available payment options. You pay for the first instalment of 25% at the time of purchase, and the remaining three instalments will be automatically deducted from your nominated debit or credit card over the following six weeks.`}
        </div>

        <div className={`afterpay-explain-title padding-top-24`}>
          What Do You Need for BestDeals Afterpay?
        </div>
        <div className={`afterpay-explain-desc padding-top-8`}>
          • A New Zealand credit card/ debit card
          <br />
          • To be 18 years of age or over
          <br />
          • To be living in New Zealand
          <br />
          • Have a valid and verifiable email address and mobile number
          <br />
          • Be capable of entering into a legally binding contract
          <br />• Credit checks apply
        </div>
        <div
          className={`padding-top-8`}
          style={{ fontWeight: "bold", marginTop: 24 }}
        >
          <div className="afterpay-bottom-message">
            <p className="note-tip">NOTE</p>
            <p className="text">Afterpay available both on PC and Mobile</p>
            <p className="text" style={{ fontWeight: "bold" }}>
              Late fees, eligibility criteria and T&amp;Cs apply. Afterpay
              Australia Pty Ltd Australian Credit Licence 527911.&nbsp;For full
              terms and conditions visit{" "}
              <Link href="https://www.afterpay.com/terms" legacyBehavior>
                <a rel="noopener noreferrer" target="_blank">
                  www.afterpay.com/terms
                </a>
              </Link>
              .
            </p>
          </div>
        </div>

        {/* 在组件渲染部分 */}
        <div className={"category-box"}>
          {categoryProduct.map((category) => (
            <section key={category.categoryId} className={"category-item"}>
              <div className={"category-name"}>{category.categoryName}</div>

              <div className={"product-list"}>
                {category.items.map((product: ProductType) => (
                  <div className={"product-item"} key={product.productID}>
                    <ProductItem product={product} showAfterpaybenifit={true} />
                  </div>
                ))}
              </div>
            </section>
          ))}
          <Link href={"/"} legacyBehavior>
            <a rel="noopener noreferrer">
              <div className="continue-btn">
                <Button type="primary" block>
                  Continue Shopping
                </Button>
              </div>
            </a>
          </Link>
        </div>
      </div>

      <ImagePreview
        visible={imgVisible}
        onClose={() => setImgVisible(false)}
        images={imagesArr}
        showIndicators
        showIndex={false}
      />
    </div>
  );
}
